import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage } from '../../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import LayoutContent from '../../../components/layouts/content2';
import {useTranslation} from 'react-i18next';
import translate from '../../../helpers/translate';
import translateMenu from '../../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import { getImageUrl } from '../../../helpers/imageUrls';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    
    const location = useLocation();
    const { dishs } = location.state || {};

    const { menus, name: title } = dishs;

    const [combo1, setCombo1] = useState(false);
    const [combo2, setCombo2] = useState(false);
    const [combo3, setCombo3] = useState(false);

    const [titleCategorie, setIitleCategorie] = useState('');

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);


    useEffect(() => {
        if (menus) {
            menus.map((item) => {
                if (item.id === 744) {
                setCombo1(item);
                }
                if (item.id === 745) {
                setCombo2(item);
                }
                if (item.id === 746) {
                setCombo3(item);
                }
            });
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);
    


    const fetchImage = async (id) => {
        // Una sola object URL por imagen, compartida y con tope LRU (helpers/imageUrls).
        return getImageUrl(id);
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);



        
        return (
            <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: 'white', marginBottom: 30, textDecoration: 'none', 
                width: 300,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative'
            }}>
                <img src={image}  style={{width: 300, height: 300, objectFit: 'cover'}}/>
                <h3 style={
                    { fontFamily: "LondrinaSolidRegular", color: 'black', textTransform: 'uppercase', fontSize: 27, margin: 0, marginLeft: 25, marginTop: 10, marginRight: 25 }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{width: '95%', marginTop: 10}}>
                    <p
                        className='shor-text'
                        style={{ fontFamily: "LondrinaSolidLight",fontSize: 20, color: '#959595', margin: 0,marginLeft: 25,fontWeight: 'bold'}}>

                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>

                <div style={{
                     position: 'absolute',
                        bottom: 0,
                        right: 10,
                        paddingTop: 1,
                        paddingBottom: 5,
                        backgroundColor: 'white',
                }}>
                    <div>
                        <p
                        style={
                           {color: '#b8272e', fontSize: 30, fontWeight: 'bold', margin: 0, fontWeight: '900'}
                        }>
                        ${data.price.toFixed(2)}
                        </p>
                    </div>
                    <div>
                        <div style={{flexDirection: 'row'}}>
                        </div>
                    </div>
                </div>
                
                
            </div>
        );
    }
    return (
         <LayoutContent showBack={false}>
            <div>

                <div style={{
                    zIndex: -1,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 40px',
                 
                }}>
                    <p style={{  fontFamily: "LondrinaSolidRegular",fontSize: 50, color: 'white', fontWeight: '900', margin: 0 }}>{titleCategorie}</p>
                    
                     <Link to={`/`} style={{
                         width: 161,
                        textAlign: 'center',
                        textDecoration: "none",
                         color: 'black'
                    }}>
                        <div
                            style={
                                {
                                    borderRadius: 5,
                                    textAlign: 'center',
                                    padding: 2,
                                    backgroundColor: '#f3a539',
                                }
                            }
                          >
                            <div
                            style={{
                                padding: 10,
                                paddingVertical: 15,
                                borderColor: '#b8272e',
                                borderWidth: 2,
                                borderStyle: 'solid'
                            }}>
                            <p
                                    style={{
                                    fontFamily: "LondrinaSolidRegular",
                                    textAlign: 'center', 
                                    alignSelf: 'center',
                                    fontSize: 23,
                                    textTransform: 'uppercase',
                                        fontWeight: '900',
                                   
                                    }}>
                                    {langEng ? "Back": "Volver al menú"}
                               
                            </p>
                            </div>
                        </div>
                    </Link>
                    
                </div>


                {dishs.id === 61 ? (
                
                 <div
                    style={{
                    width: '100%',
                    alignItems: 'center',
                    padding: '0px 40px 100px 40px',
                            boxSizing: 'border-box',
                    marginTop: 40
                    }}>
                        <Link
                            to="/MenuDetail" state={{ dish: combo1, alldish: menus, currentDish: dishs }} 
                        style={{width: '100%'}}
                        >
                    <img
                        src={require('./assets/combo1.png')}
                        style={{width: '100%', height: 200, objectFit: 'contain'}}
                    />
                        </Link>
                        <br />
                        <br/>
                    <Link
                        to="/MenuDetail" state={{ dish: combo2, alldish: menus, currentDish: dishs }} 
                        style={{width: '100%'}}
                    >
                    <img
                        src={require('./assets/combo2.png')}
                        style={{width: '100%', height: 200, objectFit: 'contain'}}
                    />
                        </Link>
                        <br />
                        <br/>

                    <Link
                        style={{ width: '100%' }}
                        to="/MenuDetail" state={{ dish: combo3, alldish: menus, currentDish: dishs }} 
                    >
                    <img
                        src={require('./assets/combo3.png')}
                        style={{width: '100%', height: 200, objectFit: 'contain'}}
                    />
                    </Link>
                </div>
                 ): (
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        padding: '0px 40px 100px 40px',
                        overflow: 'scroll',
                        height: 800,
                        
                    }}>
                        {menus.map((item, key) => (
                            <Item data={ item }  key={key} />
                        ))}
                    </div>   
                )
                 
            }

               
               
            </div>

            {showDetailProduct && <DetailProduct
                dishMenu={dataDish}
                setShowDetailProduct={setShowDetailProduct}
            />}
        </LayoutContent>
    );
}

export default Index;